"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkIfBunkruptcy = exports.checkIfBroker = exports.checkIfInsurancePage = exports.checkIfSchool = exports.checkIfMfo = void 0;
const constants_1 = require("../organizations/constants");
const types_1 = require("../organizations/types");
const checkIfMfo = (type) => {
    return constants_1.MFO_PAGE_TYPE.includes(type) || type === types_1.OrganizationTypes.Mfo;
};
exports.checkIfMfo = checkIfMfo;
const checkIfSchool = (type) => {
    return constants_1.SCHOOL_PAGE_TYPE.includes(type);
};
exports.checkIfSchool = checkIfSchool;
const checkIfInsurancePage = (type) => {
    return constants_1.INSURANCE_COMPANY_PAGE_TYPE.includes(type);
};
exports.checkIfInsurancePage = checkIfInsurancePage;
const checkIfBroker = (type) => {
    return constants_1.BROKER_PAGE_TYPE.includes(type);
};
exports.checkIfBroker = checkIfBroker;
const checkIfBunkruptcy = (type) => {
    return constants_1.BANKRUPTCY_PAGE_TYPE.includes(type);
};
exports.checkIfBunkruptcy = checkIfBunkruptcy;
